<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">{{ 'VENUES.VENUES_SEO_FORM.EDIT' | translate }} - {{ venueSeo?.name }}</h4>
  <button type="button" class="close btn-close-templates" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body p-0 d-flex flex-column">
  <form
    id="venue-seo-form"
    (ngSubmit)="save()"
    [formGroup]="form"
    novalidate
    class="d-flex overflow-hidden flex-grow-1"
  >
    <ng-scrollbar class="locales-menu ps">
      <div class="modal-section-title mt-2 mb-2 ps-2">
        {{ 'VENUES.VENUES_SEO_FORM.WEBSITES_LIST_TITLE' | translate }}
      </div>

      <div
        *ngFor="let websiteLocale of companyWebsiteLocales"
        (click)="selectCompanyWebSiteLocale(websiteLocale.id)"
        class="website-locale d-flex"
        [ngClass]="{ active: currentWebsiteLocaleId === websiteLocale.id }"
      >
        <div class="ico">
          <i class="fal fa-chevron-right"></i>
        </div>
        <div class="name">{{ websiteLocale.website.name }} - {{ websiteLocale.website.url }}</div>
        <div class="flag">
          <span class="flag-icon" [ngClass]="'flag-icon-' + websiteLocale.locale.locale"></span>
        </div>
      </div>
    </ng-scrollbar>

    <div class="flex-grow-1 overflow-auto">
      <div class="locales-content-wrapper" formArrayName="websiteLocales">
        <div *ngIf="!currentWebsiteLocaleId" class="modal-section-title ps-3 mt-2">
          {{ 'VENUES.VENUES_SEO_FORM.SELECT_WEBSITE_MSG' | translate }}
        </div>

        <div *ngFor="let websiteLocale of form.get('websiteLocales')?.controls; let i = index" class="locales-content">
          <div
            [formGroupName]="i"
            *ngIf="currentWebsiteLocaleId === websiteLocale.get('company_website_locale_id').value"
          >
            <div class="modal-section-title mt-2 mb-2">
              {{ getWebsiteLocaleName(websiteLocale.get('company_website_locale_id').value) }}
            </div>

            <div class="form-group">
              <label>{{ 'VENUES.VENUES_SEO_FORM.DESCRIPTION' | translate }}</label>
              <app-editor
                [form]="websiteLocale"
                passFormControlName="description"
                [autoResize]="false"
                [attrs]="{ height: 400, min_height: null }"
              ></app-editor>
            </div>

            <div class="form-group">
              <label>{{ 'VENUES.VENUES_SEO_FORM.HOW_TO_GET_BY_FOOT' | translate }}</label>
              <app-editor
                [form]="websiteLocale"
                passFormControlName="how_to_get_by_foot"
                [autoResize]="false"
                [attrs]="{ height: 400, min_height: null }"
              ></app-editor>
            </div>

            <div class="form-group">
              <label>{{ 'VENUES.VENUES_SEO_FORM.HOW_TO_GET_BY_CAR' | translate }}</label>
              <app-editor
                [form]="websiteLocale"
                passFormControlName="how_to_get_by_car"
                [autoResize]="false"
                [attrs]="{ height: 400, min_height: null }"
              ></app-editor>
            </div>

            <div class="form-group">
              <label>{{ 'VENUES.VENUES_SEO_FORM.HOW_TO_GET_BY_PUBLIC' | translate }}</label>
              <app-editor
                [form]="websiteLocale"
                passFormControlName="how_to_get_by_public"
                [autoResize]="false"
                [attrs]="{ height: 400, min_height: null }"
              ></app-editor>
            </div>

            <div class="form-group">
              <label>{{ 'VENUES.VENUES_SEO_FORM.RELOCATED' | translate }}</label>
              <app-editor
                [form]="websiteLocale"
                passFormControlName="relocated"
                [autoResize]="false"
                [attrs]="{ height: 400, min_height: null }"
              ></app-editor>
            </div>

            <div class="form-group">
              <label>{{ 'VENUES.VENUES_SEO_FORM.VIDEO_URL' | translate }}</label>
              <input type="text" class="form-control" formControlName="video_url" />
            </div>

            <div class="form-group">
              <label>{{ 'VENUES.VENUES_SEO_FORM.SLUG' | translate }}</label>
              <input type="text" class="form-control" formControlName="slug" />
            </div>

            <div class="form-group">
              <label>{{ 'VENUES.VENUES_SEO_FORM.META_TITLE' | translate }}</label>
              <input type="text" class="form-control" formControlName="meta_title" />
            </div>

            <div class="form-group">
              <label>{{ 'VENUES.VENUES_SEO_FORM.META_DESCRIPTION' | translate }}</label>
              <input type="text" class="form-control" formControlName="meta_description" />
            </div>

            <div class="d-flex">
              <div class="custom-control custom-checkbox me-3">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  formControlName="active"
                  [attr.id]="'venues-seo-form-active' + i"
                />
                <label class="custom-control-label" [attr.for]="'venues-seo-form-active' + i">
                  {{ 'VENUES.VENUES_SEO_FORM.ACTIVE' | translate }}
                </label>
              </div>

              <div class="custom-control custom-checkbox me-3">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  formControlName="top"
                  [attr.id]="'venues-seo-form-top' + i"
                />
                <label class="custom-control-label" [attr.for]="'venues-seo-form-top' + i">
                  {{ 'VENUES.VENUES_SEO_FORM.TOP' | translate }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="submit" class="btn btn-outline-dark btn-xs" form="venue-seo-form" [disabled]="form.invalid">
    {{ 'VENUES.VENUES_SEO_FORM.SAVE' | translate }}
  </button>
</div>
